module.exports = __webpack_public_path__ + "static/3-aff07d6679b928d2119b92a49c373dae.jpg";